<template>
  <div>
    <v-row>
      <v-col md="6" :cols="12" class="pt-0 pb-5">
        <div class="participant-header">Participant</div></v-col
      >
      <v-col md="6" :cols="12" class="pt-0 pb-5">
        <div class="tab-header-text text-right">
          <v-btn
            @click="refreshList()"
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
          >
            <v-icon left>mdi-refresh</v-icon>
            Refresh
          </v-btn>
        </div>
      </v-col>
    </v-row>

        <div class="listBorder px-5 mb-5" v-for="(participant, key) in participants.slice(((pageNumber-1) * pageItemPerPage), (pageNumber * pageItemPerPage))" :key="key">
          <v-row>
            <v-col cols="auto">
              <div>
                <v-avatar :size="55" class="text-top">
                  <img :src="participant.student.image" />
                </v-avatar>
              </div>
            </v-col>
            <v-col class="pl-0">
              <div class="container pa-0">
                <div align="left" class="vertical-center">
                  <div class="nameLabel">{{ participant.student.firstName }} {{ participant.student.lastName }}</div>
                  <div class="emailLabel">{{ participant.student.email }}</div>
                </div>
              </div>
            </v-col>
            <v-col cols="auto">
              <div class="container" style="width:80px">
                <div align="right" class="timeLabel vertical-center">{{(new Date(participant.created_at)).getHours() }}:{{ (new Date(participant.created_at)).getMinutes() >= 10 ? (new Date(participant.created_at)).getMinutes() :`0${(new Date(participant.created_at)).getMinutes()}` }} น.</div>
              </div>
            </v-col>
          </v-row>
        </div>

      <v-row justify="end" class="pt-5">      
        <div>
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(participants.length/pageItemPerPage)"
          ></v-pagination>
        </div>
      </v-row>

<!-- 
          <div class="message-box" :key="key" v-for="(participant, key) in participants">
            <v-card color="white" elevation="0">
            <v-row>
            <v-col :cols="2" :lg="2" :md="2" :sm="2">
              <div class="chat-avatar">
                <v-avatar :size="55" class="text-top">
                  <img :src="participant.student.image" />
                </v-avatar>
              </div>
              </v-col>
            <v-col :cols="8" :lg="8" :md="8" :sm="8">
                <div
                class="chat-message"
              >
                <div class="chat-name">{{participant.student.displayName}}</div>
                <div class="gray-font">{{participant.student.email}}</div>
              </div>
            </v-col>
            <v-col :cols="2" :lg="2" :md="2" :sm="2">
              <div>
                <div
                class="gray-font"
              >
                <div>{{(new Date(participant.created_at)).getHours() }}:{{ (new Date(participant.created_at)).getMinutes() >= 10 ? (new Date(participant.created_at)).getMinutes() :`0${(new Date(participant.created_at)).getMinutes()}` }}</div>
              </div>
              </div>
            </v-col>
          </v-row>
            </v-card>-->
            <!-- <v-card color="white" elevation="0">
              <div class="chat-avatar">
                <v-avatar :size="50" class="text-top">
                  <img :src="participant.student.image" />
                </v-avatar>
              </div>
              <div
                :class="participant.userID === ownerID ? 'chat-message owner-message':'chat-message'"
              >
                <div class="chat-name">{{participant.student.displayName}}</div>
                <div>{{participant.student.email}}</div>
              </div>
              <div
                :class="participant.userID === ownerID ? 'chat-time owner-message':'chat-time'"
              >
                <div>{{(new Date(participant.created_at)).getHours() }}:{{ (new Date(participant.created_at)).getMinutes() >= 10 ? (new Date(participant.created_at)).getMinutes() :`0${(new Date(participant.created_at)).getMinutes()}` }}</div>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
import { getJoinedLearner } from "@/service/course/livev2";
// var coursesRef = database
//   .ref("/courses")
//   .child("/course12")
//   .child("/live30");

// var onlineUserRef = database.ref("/onlineUser").child("/live30");

// var connectedRef = database.ref(".info/connected");
// import { getLiveStreamStudio } from "@/service/course/live";
// import $ from "jquery";
export default {
  name: "login",
  props: {
    courseId: {
      type: String
    },
    liveId: {
      type: String
    }
  },
  data: () => ({
    participants: [],
    pageNumber: 1,
    pageItemPerPage: 10,
  }),
  mounted() {
    this.init();
  },
  computed: {},
  methods: {
    init(){
      this.getParticipantList();
    },
    async getParticipantList(){
      let result = await getJoinedLearner(this.liveId);
      this.participants = result;
    },
    refreshList(){
      this.getParticipantList();
      this.pageNumber = 1;
    }
  }
};
</script>
<style lang="scss" scoped>
.participant-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}


.container {
  height: 100%;
  position: relative;
}

.vertical-center {
  width: 100%;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.listBorder {
  border-style: solid;
  border-radius: 10px;
  border-width: 2px;
  border-color: #cfcfcf;
}


.nameLabel {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #4a4a4a;
}

.emailLabel {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  color: #9b9b9b;
}

.timeLabel {
  color: #4a4a4a;
}
</style>